package com.schoolconnect.app.feature.attendance

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember

@Composable
fun AttendanceFeatureRoute(
    onBack: () -> Unit,
    schoolId: String = "",
    shellRoleCode: String = "",
    shellSchoolLabel: String = "iConnect.School",
    onChangeRole: () -> Unit = onBack,
    onLogout: () -> Unit = {}
) {
    val viewModel = remember(shellRoleCode, schoolId) { AttendanceViewModel(shellRoleCode, schoolId) }
    val uiState by viewModel.uiState.collectAsState()

    DisposableEffect(viewModel) {
        onDispose { viewModel.clear() }
    }

    AttendanceScreen(
        state = uiState,
        onEvent = viewModel::onEvent,
        onBack = onBack,
        shellRoleCode = shellRoleCode,
        shellSchoolLabel = shellSchoolLabel,
        onChangeRole = onChangeRole,
        onLogout = onLogout
    )
}
